import { ICreateCargoUseCase } from "../../../presentation/useCases/create/create_cargo_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateCargoUseCase
 */

export class CreateCargoUseCase implements ICreateCargoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async createCargo(
    ativo: number,
    descricao: string,
    atribuicoes: string,
    escolaridade: string,
    experiencia: string,
    qualificacoes: string,
    treinamentos: number[],
    habilidades: number[],
  ): Promise<number> {
    return await this.repository.createCargo(
      ativo,
      atribuicoes,
      descricao,
      escolaridade,
      experiencia,
      qualificacoes,
      treinamentos,
      habilidades,
    );
  }
}
